module.exports = __webpack_public_path__ + "img/scene21.cebb4c26.gif";